import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DxToolbarComponent} from 'devextreme-angular';
import {FlowMeterRequest} from '../flow-meter-request';
import {dateFilters, dateFilterToPeriod} from 'shared';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-flow-meter-report-toolbar',
  templateUrl: './flow-meter-report-toolbar.component.html',
  styleUrls: ['./flow-meter-report-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowMeterReportToolbarComponent implements OnInit {

  @ViewChild(DxToolbarComponent, {static: true})
  toolbar: DxToolbarComponent;

  @Output()
  load = new EventEmitter<FlowMeterRequest>();

  @Output()
  export = new EventEmitter<void>();

  @Output()
  openDrawer = new EventEmitter<void>();

  @Input()
  loadingVisible = true;

  @Input()
  request: FlowMeterRequest;

  @Input()
  tractors: DataSource;

  @Input()
  selectedTractors: any[];

  generateButtonOptions: any;
  exportButtonOptions: any;
  drawerButtonOptions: any;
  dateFilters = dateFilters;
  showDrawer;

  constructor() {
  }

  ngOnInit(): void {

    this.generateButtonOptions = {
      icon: 'repeat',
      text: 'Génerer',
      onClick: (e: any) => {
        const result = e.validationGroup.validate();
        if (result.isValid) {
          this.load.emit(this.request);
        }
      }
    };

    this.showDrawer = () => {
      this.openDrawer.emit();
    };

    this.drawerButtonOptions = {
      icon: 'ld-tractor',
      text: 'Tracteurs',
      onClick: () => {}
    };

    this.exportButtonOptions = {
      icon: 'image',
      text: 'Exporter',
      onClick: () => {
        this.export.emit();
      }
    };
  }

  dateFilterChanged(e) {
    this.request.isToday = false;
    if (this.request.currentFilter === 0 || e.value === 0) {
      setTimeout(() => {
        this.toolbar.instance.repaint();
      }, 100);
    }
    this.request.currentFilter = e.value;
    [this.request.from, this.request.to, this.request.isToday] = dateFilterToPeriod(this.request.currentFilter);
  }

}
